import { validateEmail } from '../../../utils';
import { EmailProviders, FormValues } from './types';

export const maxFieldLength = 64;
export const maxSendGridKeyLength = 100;

export const EmailProvidersValidator = (
  values: FormValues
): Record<string, string | Record<string, unknown>> => {
  const errors: Record<string, string | Record<string, unknown>> = {
    provider_settings: {}
  };

  if (values && values.custom_email && values.custom_email.length > maxFieldLength) {
    errors.custom_email = 'app.validation.characters';
  }

  if (values && values.custom_email && !validateEmail(values.custom_email)) {
    errors.custom_email = 'users.settings.email.validation.invalid';
  }

  if (values && values.from_email_name && values.from_email_name.length > maxFieldLength) {
    errors.from_email_name = 'app.validation.characters';
  }

  Object.entries(values.provider_type)
    .filter(([, value]) => value)
    .forEach(([provider]) => {
      // ToDo: change, when SMTP implemented
      // if (
      //   provider === EmailProviders.send_grid &&
      //   (!values.provider_settings || !values.provider_settings.sendgrid_api_key)
      // ) {
      //   (errors.provider_settings as Record<string, unknown>).sendgrid_api_key =
      //     'app.validation.required';
      // }

      if (
        provider === EmailProviders.send_grid &&
        values.provider_settings &&
        values.provider_settings.sendgrid_api_key &&
        values.provider_settings.sendgrid_api_key.length > maxSendGridKeyLength
      ) {
        (errors.provider_settings as Record<string, unknown>).sendgrid_api_key =
          'app.validation.characters';
      }

      if (
        provider === EmailProviders.send_grid &&
        values.provider_settings &&
        values.provider_settings.sendgrid_api_key &&
        !values.custom_email
      ) {
        errors.custom_email = 'app.validation.required';
      }

      if (
        provider === EmailProviders.send_grid &&
        values.provider_settings &&
        !values.provider_settings.sendgrid_api_key &&
        values.custom_email
      ) {
        (errors.provider_settings as Record<string, unknown>).sendgrid_api_key =
          'app.validation.required';
      }
    });

  return errors;
};
